import React from 'react';
import s from './styles.module.css.json';
export function FieldHint(_a) {
    var children = _a.children;
    return React.createElement("div", { className: s.fieldHint }, children);
}
//# sourceMappingURL=index.js.map